import React from 'react'

import copy from 'copy-to-clipboard'

interface CopyOptions {
  debug?: boolean
  message?: string
  format?: string
}

interface CopyToClipboardProps {
  text: string
  children: React.ReactElement<{
    onClick?: (event: React.MouseEvent<HTMLElement>) => void
  }>
  onCopy?: (text: string, result: boolean) => void
  options?: CopyOptions
}

export const CopyToClipboard = ({
  text,
  children,
  onCopy,
  options,
  ...props
}: CopyToClipboardProps): React.ReactElement => {
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    const elem = React.Children.only(children)
    const result = copy(text, options)

    onCopy?.(text, result)

    // Bypass onClick if it was present
    elem.props.onClick?.(event)
  }

  const elem = React.Children.only(children)
  return React.cloneElement(elem, {
    ...props,
    onClick: handleClick,
  } as React.HTMLAttributes<HTMLElement>)
}
